import { render, staticRenderFns } from "./ServicesListWidget.vue?vue&type=template&id=4e3a46c3&scoped=true"
import script from "./ServicesListWidget.vue?vue&type=script&lang=js"
export * from "./ServicesListWidget.vue?vue&type=script&lang=js"
import style0 from "./ServicesListWidget.vue?vue&type=style&index=0&id=4e3a46c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3a46c3",
  null
  
)

export default component.exports